import { render, staticRenderFns } from "./TheScienceSection.vue?vue&type=template&id=4c698934&scoped=true&"
import script from "./TheScienceSection.vue?vue&type=script&lang=ts&"
export * from "./TheScienceSection.vue?vue&type=script&lang=ts&"
import style0 from "./TheScienceSection.vue?vue&type=style&index=0&id=4c698934&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c698934",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
